import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.75 12.5429V4.85C4.75 4.79477 4.79477 4.75 4.85 4.75H12.5429C12.6755 4.75 12.8027 4.80268 12.8964 4.89645L20.1464 12.1464C20.3417 12.3417 20.3417 12.6583 20.1464 12.8536L12.8536 20.1464C12.6583 20.3417 12.3417 20.3417 12.1464 20.1464L4.89645 12.8964C4.80268 12.8027 4.75 12.6755 4.75 12.5429Z" vectorEffect="non-scaling-stroke" />
		<Path d="M14.1563 12.7915L12.7421 14.2057C11.2807 12.7443 13.0603 11.6955 11.9643 10.5995C11.4163 10.0515 10.2495 10.2989 10.0904 11.554" strokeLinecap="square" vectorEffect="non-scaling-stroke" />
	</SVG>
);
